import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';

interface SidebarSectionProps {
    children: React.ReactNode;
    title: string;
    containerClassName?: string;
}

const SidebarSection = ({
    children,
    title,
    containerClassName,
}: SidebarSectionProps) => {
    const translate = useTranslate();

    return (
        <section className={`sidebar__section ${containerClassName || ''}`}>
            <h3 className='sidebar__title'>{translate(title)}</h3>
            {children}
        </section>
    );
};

export default SidebarSection;
